import { useEffect } from "react";
import { t } from "i18next";
import { Button, Card } from "react-bootstrap";
import useDetailsAction from "@main/customers/actions/details/useDetailsAction";
import GoBack from "@main/panel-components/GoBack";

function CustomerMainTab(props: { customerId: string, title: string, formDefaultValues: any}) {
  const { customerId, title, formDefaultValues } = props;

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate
  } = useDetailsAction(parseInt(customerId), title, formDefaultValues);

  useEffect(() => {
    if (!customerId ) return;
    getFunction(customerId);
  }, [customerId]);

  if (!customerId) return null;

  return (
    <Card>
      <Card.Header>
        <Card.Title><GoBack/> {t("main_data")}</Card.Title>
      </Card.Header>

      <Card.Body>
        {actionTemplate}
      </Card.Body>

      <Card.Footer>
        <Button variant="primary" onClick={onSubmitFunction}>
          {t('save_changes')}
        </Button>
      </Card.Footer>
    </Card>
  );
}

export default CustomerMainTab;
